import { render, staticRenderFns } from "./AdminTravelServiceItemReadonlyView.vue?vue&type=template&id=05bdc2e9&"
import script from "./AdminTravelServiceItemReadonlyView.vue?vue&type=script&lang=js&"
export * from "./AdminTravelServiceItemReadonlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05bdc2e9')) {
      api.createRecord('05bdc2e9', component.options)
    } else {
      api.reload('05bdc2e9', component.options)
    }
    module.hot.accept("./AdminTravelServiceItemReadonlyView.vue?vue&type=template&id=05bdc2e9&", function () {
      api.rerender('05bdc2e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/travel-service/AdminTravelServiceItemReadonlyView.vue"
export default component.exports